<div class="tag">
  <!-- telemetry today -->
  @if (tag === 'gateways-telemetry-today') {
    <div class="col-xs-12">
      @if (!selectedAsset) {
        <div class="telemetry" [hidden]="gettingData">
          <!-- Loop arrays of gateways -->
          @for (gatewayAssets of results; track gatewayAssets; let gi = $index) {
            <div class="gateway-container">
              <!-- Display the gateway -->
              @if (!selectedAsset) {
                <div [ngClass]="{ 'gateway-is-offline': gatewayAssets[0].gatewayOnline === 'offline' }" title="{{ gatewayAssets[0].gatewayOnline }}" class="col-md-12 gateway-title"><i class="fa fa-circle" [ngClass]="{ 'status-online': gatewayAssets[0].gatewayOnline === 'online', 'status-standby': gatewayAssets[0].gatewayOnline === 'standby', 'status-offline': gatewayAssets[0].gatewayOnline === 'offline' }"></i> {{ gatewayAssets[0].gatewayTitle }}</div>
              }
              @for (assetValue of gatewayAssets; track assetValue; let i = $index) {
                <div class="col-md-6 col-lg-6">
                  <app-dashboard-telemetry-asset [asset]="assetValue" (onAssetClick)="showTelemetry(assetValue)"></app-dashboard-telemetry-asset>
                </div>
              }
            </div>
          }
          @if (results?.length === 0) {
            <div>No telemetry available.</div>
          }
        </div>
      }
      @if (selectedAsset) {
        <div class="asset-view">
          <div class="go-back">
            <span (click)="selectedAsset = null"><i class="fa fa-chevron-left"></i> Back to gateways</span>
          </div>
          <app-asset-viewer [assetId]="selectedAsset.assetId"></app-asset-viewer>
          <!--<app-asset-view [assetId]="selectedAsset.assetId"></app-asset-view>-->
        </div>
      }
      <div class="telemetry-data" [hidden]="!selectedAsset"></div>
    </div>
  }
</div>
